import { FeatureAppLoader } from '@feature-hub/react';
import {
  CTA,
} from '@volkswagen-onehub/components-core';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureServices } from 'src/feature-app';
import { getMarketingCode } from 'src/feature-app/utils';
import {
  CarlineContext,
  useFeatureAppService,
  useTrackingManager,
} from 'src/feature-app/hooks';
import { OffersState } from 'src/feature-app/redux/reducer';
import { Offer } from 'src/types';
import { CarlineModelCuotaInfoProps } from '.';

export const RedirectCTAs = (props: CarlineModelCuotaInfoProps) => {
  const { offer } = props;
  const trackingManager = useTrackingManager();
  const [showOneForm, setShowOneForm] = useState<boolean>(false);
  const [showOneFormCallMe, setShowOneFormCallMe] = useState<boolean>(false);
  const featureAppRef = useRef(null);
  const featureAppService = useFeatureAppService();
  const carline = useContext(CarlineContext);
  const [marketingCodeLoaded, setMarketingCodeLoaded] = useState(false);
  //mostrar o no el CTA de CallMeNow
  const hour = dayjs().hour();
  const minute = dayjs().minute();

  const [isCommercialsPage, setIscommercialsPage] = useState<boolean | null>(null);
  const [showCTACallMe, setShowCTACallMe] = useState<boolean>(false);
  const isCallCenterOpen = useSelector((state: OffersState) => state.isCallCenterOpen);

  useEffect(() => {
    if (carline && carline.brand === 'N') {
      setIscommercialsPage(true);
    } else {
      setIscommercialsPage(false);
    }
  }, [carline]);

  useEffect(() => {
    if (isCommercialsPage && hour >= 9 && hour < 19) {
      setShowCTACallMe(true);
    } else if (isCommercialsPage && hour === 19 && minute < 30) {
      setShowCTACallMe(true);
    } else {
      setShowCTACallMe(false);
    }
  }, [isCommercialsPage]);

  const marketingCodeConfigRef = useRef(null);

  const renderOneFormFA = (): JSX.Element => {
    return (
      <CTA
        emphasis="primary"
        size="large"
        tag="button"
        onClick={(e) => {
          setShowOneForm(true);
        }}
      >
        Pide esta oferta
      </CTA>
    );
  };

  const renderExternal = (link: string): JSX.Element => {
    return (
      <CTA emphasis="primary" size="large" tag="a" href={link}>
        Encuentra el tuyo
      </CTA>
    );
  };

  const renderOneFormFACallMe = (): JSX.Element => {
    return isCallCenterOpen ? (
      <div style={{ paddingTop: '20px' }}>
        <CTA
          emphasis="secondary"
          size="large"
          tag="button"
          onClick={(e) => {
            setShowOneFormCallMe(true);
          }}
        >
          ¿Te llamamos?
        </CTA>
      </div>
    ) : null;
  };

  const getDpsFields = (offer: Offer) => {
    if (!offer.promociones || offer.promociones.length === 0) {
      return null;
    }

    const value = offer.promociones.map((promo) => promo.name);

    return [
      {
        field: 'headers[DETALLE_TIPO_PETICION_SIM]',
        value,
      },
    ];
  };

  const renderOneForm = (offer: any) => {
    if (showOneForm) {
      const featureApp = featureAppService.featureAppConfigurations['es-oneform-lead-embedded'];
      featureAppRef.current = featureApp;
    } else if (showOneFormCallMe) {
      const featureApp = featureAppService.featureAppConfigurations['es-oneform-callme-embedded'];
      featureAppRef.current = featureApp;
    }

    return (
      <FeatureAppLoader
        {...featureAppRef.current}
        // src="http://localhost:3001/vw-oneform-feature-app.umd.js"
        featureAppId={`${featureAppRef.current.name}:oneform`}
        done={() => {
          setShowOneForm(false);
          setShowOneFormCallMe(false);
        }}
        beforeCreate={(env) => {
          env.featureServices['fa-content-service'].content = {
            featureApp: 'es-ofertas',
            oferta: offer,
            marketingCodeConfig: marketingCodeConfigRef.current,
            // dpsFields: getDpsFields(offer),
          };
          if (env.featureServices['api-key-provider']) {
            env.featureServices['api-key-provider'].apiKey = featureAppRef.current.apiKey;
          }
          if (env.featureServices.tracking) {
            env.featureServices.tracking.contextualEventData = {
              event: {
                environment: {
                  featureAppId: featureAppRef.current.trackingId,
                },
              },
            };
          }
        }}
      />
    );
  };

  const trackCTAClick = async (text: string): Promise<void> => {
    const { marketingCodeConfig } = await getMarketingCode(offer.marketingCode);
    marketingCodeConfigRef.current = marketingCodeConfig;
    trackingManager.trackOffersVehicleButtonClick(offer, { contentId: text }, marketingCodeConfig);
    setMarketingCodeLoaded(true);
  };

  const handleOneFormCTAClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, copy: string) => {
    e.preventDefault();
    trackCTAClick(copy);
  };
  
  return (
    <>
      <div style={{ paddingTop: '32px' }} className="botton-wrapper">
        {offer.financiacionText?.includes('Ocasión') ?
          <div>
            {renderExternal(offer.ocasion.dwaURL)}
          </div>
          :
          <div
            onClick={(e) => {
              handleOneFormCTAClick(e, 'Pide esta oferta');
            }}
          >
            {renderOneFormFA()}
          </div>
        }
        {showCTACallMe ? (
          <div
            onClick={(e) => {
              handleOneFormCTAClick(e, '');
            }}
          >
            {renderOneFormFACallMe()}
          </div>
        ) : null}
      </div>
      {showOneForm && marketingCodeLoaded ? renderOneForm(offer) : null}
      {showOneFormCallMe && marketingCodeLoaded ? renderOneForm(offer) : null}
    </>
  );
};
